import { ScreenLayout } from "../../layout/components";
import { MainStackScreenProps } from "../../navigation/Navigation.types";
import { addPlayerForm } from "./AddPlayer.types";
import { useAddPlayer } from "./useAddPlayer";
import { Button, Div, FormBuilder, H2, Icon } from "@grassrootly/rn-core";

export default function AddPlayerScreen({ navigation, route: { params } }: MainStackScreenProps<"add-player">) {
  const { adding, onAddPlayer, goBack, loadingForm } = useAddPlayer({
    navigation,
    id: params?.id,
    whereToAdd: params?.whereToAdd,
  });

  return (
    <ScreenLayout
      header={{
        center: `ADD PLAYER`,
        left: <Icon name="arrow_back_ios" size={24} onPress={goBack} classNames={["mb-{5}"]} />,
      }}
    >
      <Div classNames={["flex1", "mt-{90}"]}>
        <H2 classNames={["h4"]}>Add Player to {params.whereToAdd === "game" ? "Game" : "Group"}</H2>
        <Div classNames={["flex1", "w100", "mt-{24}"]}>
          {!loadingForm && (
            <FormBuilder
              form={addPlayerForm}
              onSubmit={onAddPlayer}
              submitControl={(submit) => (
                <Button
                  title="Save"
                  classNames={["btnBlock", "mt-{24}"]}
                  isLoading={adding}
                  disabled={adding}
                  type="button"
                  onPress={submit}
                />
              )}
            />
          )}
        </Div>
      </Div>
    </ScreenLayout>
  );
}
